import { ListQuery, PagedRequest } from '../api/apiTypes';

export default function toPagedRequest<T>(query: ListQuery<T>, pageSize: number): PagedRequest<T> {
  return { ...query, pageSize };
}
